import * as React from "react"
import { Heading, Subhead, Text } from "./ui"

export default function HomeLogo() {
  return <Subhead center>Fair Haven Village Inn</Subhead>
}
